import ProjectInnerPage from './project-inner-page';
export default ProjectInnerPage; 